import { useCallback, useMemo } from "react";

export const useRudderstackTrack = (
  eventName: string,
  baseProperties?: Record<string, unknown>,
) => {
  const memoizedBaseProperties = useMemo(
    () => baseProperties,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(baseProperties)],
  );
  return useCallback(
    (properties?: Record<string, unknown>) =>
      window.rudderanalytics?.track(eventName, {
        ...memoizedBaseProperties,
        ...properties,
      }),
    [eventName, memoizedBaseProperties],
  );
};
